module.exports = __webpack_public_path__ + "img/en.bbf79b17.png";